var map = {
	"./GameEnd.webp": 5255,
	"./IfActivated.webp": 5846,
	"./base.webp": 785,
	"./blue.webp": 5700,
	"./green.webp": 5491,
	"./purple.webp": 2654,
	"./webpage.webp": 5977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8488;